export default {
    "global.common.cancel": "Cancel",
    "global.modal.close": "Close",
    "global.common.update_OK": "Confirm",
    "global.common.init": "Initializing data, please wait...",
    // "global.common.initError": "<div class=color-error>Data initialization failed.Please login again!</div>",
    "global.common.initError": "<div class=color-error>Loading...,Please Wait.</div>",
    "global.common.newInitError": "<div class=color-error>loading, please wait...</div>",
    "global.common.maxlist": "Maximum Limited Quantity {count}",
    "global.common.noDataText": "No relevant data at present",
    "global.common.nodata": "No relevant data was found.",
    "global.common.operation": "Operate",
    "global.common.operates": "More",
    "global.common.organization": "Organization",
    "global.common.pageError": "Sorry, there was an error loading the page!",
    "global.common.panel": "Main panel",
    "global.common.reset": "Reset",
    "global.common.search": "Search",
    "global.common.searchs": "More",
    "global.common.signout": "Sign out",
    "global.datepicker.clear": "clear",
    "global.datepicker.confirm": "confirm",
    "global.datepicker.month": "{month}",
    "global.datepicker.selectDate": "selectDate",
    "global.datepicker.selectTime": "selectTime",
    "global.datepicker.time": "time",
    "global.common.year": "-",
    "global.common.fill_required": "This information cannot be blank. Please fill in the form",
    "global.form.warning": "Your changes may not be saved",
    "global.table.noDataText": "no data",
    "global.loading.canceljump": "Cancel Jump",
    "global.loading.delayjump": "Automatic jump after {loadingtime} seconds",
    "global.loading.jump": "Proceed",
    "global.common.operate_type": "Operation Type",
    "global.common.operate_time": "Operation Date",
    "global.common.operate_history": "Operation History",
    "global.common.operator": "Operator",
    "global.common.operate_note": "Operation Reason",
    "global.common.update_OK": "confirm",
    "global.nav.module": "MODULE",
    "global.nav.shorttip": "Find products by name/keyword (e.g. user management-list, FBA transit, etc.)",
    "global.page.goto": "go to",
    "global.page.next": "next page",
    "global.page.nextStep": "next {step} page",
    "global.page.onePageCount": "{index} of one Page",
    "global.page.page": "page",
    "global.page.pre": "pre page",
    "global.page.preStep": "pre {step} page",
    "global.page.total": "total {total} item",
    "global.common.update_OK": "no data",
    "global.common.finished": "complete",
    "global.upload.fail": "fail",
    "global.upload.residue": "residue",
    "global.common.select_attachment": "Please select the file",
    "global.upload.import": "Confirm import",
    "global.common.download_template": "Download template",
    "global.common.reset_password": "Your password has expired, please change it",
};
